module.exports = __webpack_public_path__ + "aa37a5f196ce1d2aec439d3094ac0aca.png";